/* eslint-disable function-paren-newline */
import { Style } from '@capacitor/status-bar';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ENV } from 'src/config/environments';

import { EAppTheme, IAppState } from './types';

const getInitialState = (): IAppState => ({
    title: 'La Meva Energia Portal Agents',
    loading: false,
    style: Style.Default,
    error: null,
    theme: EAppTheme.Mobile,
    selectedCity: ENV.apiEndpoints[0].key,
    lastActionStatus: null,
    selectedMenu: 'Expedients',
    screenSize: 'mobile',
});

const appSlice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        setSelectedCity: (state, action: PayloadAction<string>) => {
            localStorage.setItem('selectedCity', action.payload);
            return { ...state, selectedCity: action.payload };
        },
        setScreenSize: (state, action: PayloadAction<'mobile' | 'tablet' | 'desktop'>) => ({ ...state, screenSize: action.payload }),
        setSelectedMenu: (state, action: PayloadAction<string>) => ({ ...state, selectedMenu: action.payload }),
        setLastActionStatus: (state, action: PayloadAction<string>) => ({ ...state, lastActionStatus: action.payload }),
        clearLastActionStatus: state => ({ ...state, lastActionStatus: null }),
        setTitle: (state, action: PayloadAction<string>) => ({ ...state, title: action.payload }),
        /**
         * @param payload boolean indicating if it's loading or not, or string indicating an error
         */
        setLoadingStatus: (state, action: PayloadAction<boolean | string>) => ({
            ...state,
            loading: typeof action.payload === 'boolean' ? action.payload : false,
            error: typeof action.payload !== 'boolean' ? action.payload : null,
        }),
        setTheme: (state, action: PayloadAction<EAppTheme>) => ({ ...state, theme: action.payload }),
        toggleStatusBarStyle: (state, action: PayloadAction<Style>) => ({ ...state, style: action.payload }),
    },
});

export const { setSelectedCity, setScreenSize, setSelectedMenu, setLoadingStatus, setTitle, setTheme, toggleStatusBarStyle, setLastActionStatus, clearLastActionStatus } = appSlice.actions;

export const app = appSlice.reducer;
